import { useFormik } from 'formik';

import { initialValues } from './formData';

import { ProcedureParams } from '../../../../../shared/types/systemConfiguration/procedureParams';

export const useProcedureParamsFilters = (
    onFilter?: (data: ProcedureParams) => void
) => {
    const onSubmit = (data: ProcedureParams) => {
        if (onFilter) onFilter(data || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    return {
        formik,
    };
};
